// extracted by mini-css-extract-plugin
export default {"login-layout-footer":"footer_login-layout-footer__pko7o","login-footer-logo":"footer_login-footer-logo__vxquk"};